export default __webpack_public_path__ + "assets/ico_booking_locked-94082c2d.svg";